<template>
    <b-container>
        <b-row>
            <b-col>
                <b-table
                    :fields="table.fields"
                    :items="table.items"
                    class="mb-3 mt-3"
                    striped
                    show-empty
                    responsive
                    empty-text="No Contacts to show"
                    outlined>
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                    <template #cell(note_text)="row">
                        <pre>
                            {{row.item.note_text}}
                        </pre>
                    </template>
                        <template #cell(created_on)="row">
                            {{$moment.utc(row.item.created_on).local().format('lll')}}
                        </template>
                        <template #cell(contact_name)="row">
                            {{row.item.contact.first_name}} {{row.item.contact.last_name}}
                        </template>
                        <template #cell(organization)="row">
                            {{getOrganizationInfo(row.item.contact.primary_organization).text}}
                        </template>
                        <template #cell(aux_organization)="row">
                            {{flattenAuxOrganizations(row.item.contact.aux_organization)}}
                        </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col align="center">
                <b-button-group v-if="pages.length>1">
                    <b-button @click="searchContacts(currentPage-1)">Prev</b-button>
                    <b-button @click="searchContacts(currentPage+1)">Next</b-button>
                </b-button-group>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { MessageApi } from "@/app/messages/messageApi";
import handleError from "@/errorHandler";
export default {
    name: "MessageContactList",
    props: {
        wardId: {
            type: String,
            required: false,
            default: null
        },
        messageId: {
            type: String,
            required: false,
            default: null
        },
        organization: {
            type: String,
            required: false,
            default: null
        },
        messageState: {
            type: String,
            required: false,
            default: null
        },
        organizations: {
            type: Array,
            required: false,
            default: []
        }
    },
    data () {
        return {
            searchTerm: null,
            nextPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null
            },
            prevPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null
            },
            pages: [],
            currentPage: 0,
            lastPage: 0,
            table: {
                id: "message-contact_list",
                fields: [
                    {
                        key: "contact_name",
                        label: "Contact Name"
                    },
                    {
                        key: "contact.phone_number",
                        label: "Phone Number"
                    },
                    {
                        key: "organization",
                        label: "Organization"
                    },
                    {
                        key: "aux_organization",
                        label: "Auxilary Organizations"
                    },
                    {
                        key: "created_on",
                        label: "Sent On"
                    },
                    {
                        key: "added_by.username",
                        label: "Sent By"
                    }
                ],
                items: [],
                isBusy: false,
                totalRows: 0,
                page: {
                    index: 1,
                    size: 5
                }

            }

        }
    },
    async mounted() {
        this.pages.push(this.nextPage);
        await this.searchContacts(0);
    },
    methods: {
        async searchContacts(page) {
            if(page < 0) {
                return;
            }
            if(page > this.pages.length - 1) {
                return;
            }
            const payload =  this.pages[page];
            this.table.isBusy = true;
            payload.search_term = this.searchTerm;
            payload.message_state = 'PENDING';
            try {
                const { data } = await MessageApi.getMessageContacts(this.wardId, this.messageId, payload);
                if (data.last_evaluated_key !== null) {
                    if(!this.existInPageList(data.last_evaluated_key, this.pages))
                        this.pages.push(data.last_evaluated_key);
                }
                this.table.items = data.message_contact_list;
                this.table.isBusy = false;
                this.currentPage = page;
            } catch (e) {
                handleError(e, "Failed to fetch message notes");
            }
        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if(list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;
        },
        async refreshContactList() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchContacts(0);
        },
        getOrganizationInfo(value) {
            // console.log(`Value: ${value}`)
            if (value===null || value==="None") return {"text":"Guest-Not Available"};
            var i;
            for (i=0; i < this.organizations.length; i++) {
                if(this.organizations[i].value==value)
                    return this.organizations[i];
            }
        },

        flattenAuxOrganizations(list_of_orgs) {
            if(list_of_orgs === undefined) return 'None';
            if(list_of_orgs.length==0) return 'None';
            return list_of_orgs.map(x=>
            {
                let orgInfo = this.getOrganizationInfo(x);
                if (orgInfo === undefined)
                    return x;
                if (orgInfo.disabled)
                    return `${orgInfo.text} [Disabled]`;
                return orgInfo.text;
            }).join(', ');

        },
        async filterContacts() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchContacts(0);

        },
    }


}
</script>
<style lang="scss" scoped>
         pre {
            overflow-x: auto;
            white-space: pre-wrap;
            white-space: -moz-pre-wrap;
            white-space: -pre-wrap;
            white-space: -o-pre-wrap;
            word-wrap: break-word;
         }
</style>
